import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cx, css } from 'emotion';
import ThemeContext from '@hig/theme-context';

var AVAILABLE_ALIGNMENTS = Object.freeze(["center", "justify", "left", "right"]);
var AVAILABLE_FONT_WEIGHTS = Object.freeze([300, 400, 500, 600, 700, "bold", // same as 700
"normal" // same as 400
]);
var AVAILABLE_VARIANTS = Object.freeze(["body", "caption", "h1", "h2", "h3"]);

function stylesheet(props, themeData) {
  var customStylesheet = props.stylesheet,
      fontWeight = props.fontWeight,
      align = props.align;

  var variant = props.variant || "body";

  var styles = {
    typography: {
      color: themeData["typography." + variant + ".color"],
      display: "block",
      fontFamily: themeData["typography." + variant + ".fontFamily"],
      fontSize: themeData["typography." + variant + ".fontSize"],
      fontWeight: fontWeight || themeData["typography." + variant + ".fontWeight"],
      lineHeight: themeData["typography." + variant + ".lineHeight"],
      margin: 0,
      textAlign: align || "initial"
    }
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Typography = function (_Component) {
  _inherits(Typography, _Component);

  function Typography() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typography);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typography.__proto__ || Object.getPrototypeOf(Typography)).call.apply(_ref, [this].concat(args))), _this), _this.elementType = function () {
      var _this$props = _this.props,
          elementType = _this$props.elementType,
          variant = _this$props.variant;


      if (elementType) {
        return elementType;
      }

      return ["h1", "h2", "h3"].includes(variant) ? variant : "p";
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typography, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          align = _props.align,
          children = _props.children,
          fontWeight = _props.fontWeight,
          variant = _props.variant,
          customStylesheet = _props.stylesheet,
          elementType = _props.elementType,
          typographyRef = _props.typographyRef,
          otherProps = _objectWithoutProperties(_props, ["align", "children", "fontWeight", "variant", "stylesheet", "elementType", "typographyRef"]);

      var className = otherProps.className;


      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref2) {
          var resolvedRoles = _ref2.resolvedRoles;

          var styles = stylesheet(_extends({
            stylesheet: customStylesheet,
            align: align,
            fontWeight: fontWeight,
            variant: variant
          }, _this2.props), resolvedRoles);

          var ElementType = _this2.elementType();

          return React.createElement(
            ElementType,
            _extends({}, otherProps, {
              className: cx(css(styles.typography), className),
              ref: typographyRef
            }),
            children
          );
        }
      );
    }
  }]);

  return Typography;
}(Component);

Typography.propTypes = {
  /**
   * Sets the horizontal alignment of the text
   */
  align: PropTypes.oneOf(AVAILABLE_ALIGNMENTS),
  /**
   * Enables specifying the semantic element to be rendered by the component
   * If this prop is not provided, the semantic element will default to matching the variant (e.g. if the component
   * variant is h1, the element will be `<h1>`) or if there is no semantic element matching the variant, it
   * will default to `<p>`. You can provide elementType as a string, like "figcaption", or as a function, like
   * `({children}) => (<figcaption>{children}</figcaption>)`.
   */
  elementType: PropTypes.node,
  /**
   * Text to render
   */
  children: PropTypes.node,
  /**
   * Specifies the weight (or boldness) of the font
   */
  fontWeight: PropTypes.oneOf(AVAILABLE_FONT_WEIGHTS),
  /**
   * A callback ref that gets passed to the root HTML element
   */
  typographyRef: PropTypes.func,
  /**
   * Indicates the initial Typography style
   */
  variant: PropTypes.oneOf(AVAILABLE_VARIANTS),
  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func
};
Typography.__docgenInfo = {
  "description": "",
  "displayName": "Typography",
  "props": {
    "align": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ALIGNMENTS"
      },
      "required": false,
      "description": "Sets the horizontal alignment of the text"
    },
    "elementType": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Enables specifying the semantic element to be rendered by the component\nIf this prop is not provided, the semantic element will default to matching the variant (e.g. if the component\nvariant is h1, the element will be `<h1>`) or if there is no semantic element matching the variant, it\nwill default to `<p>`. You can provide elementType as a string, like \"figcaption\", or as a function, like\n`({children}) => (<figcaption>{children}</figcaption>)`."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Text to render"
    },
    "fontWeight": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_FONT_WEIGHTS"
      },
      "required": false,
      "description": "Specifies the weight (or boldness) of the font"
    },
    "typographyRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A callback ref that gets passed to the root HTML element"
    },
    "variant": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_VARIANTS"
      },
      "required": false,
      "description": "Indicates the initial Typography style"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    }
  }
};

export default Typography;
export { AVAILABLE_ALIGNMENTS, AVAILABLE_FONT_WEIGHTS, AVAILABLE_VARIANTS };
